import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      nav: {
        bikes: 'Le Bici',
        itineraries: 'Itinerari',
        booking: 'Prenota',
        where: 'Dove siamo',
        bookNow: 'Prenota ora',
      },
      hero: {
        tag: 'Piazza Duomo · Firenze · Centro Storico',
        title: 'Scopri Firenze',
        subtitle: 'in bicicletta',
        sub: 'Noleggio bici ed e-bike nel cuore della città. Prenota online, firma il contratto digitale e parti subito.',
        cta: 'Prenota ora',
        discover: 'Scopri le bici',
      },
      bikes: {
        title: 'Scegli la tua bici',
        eyebrow: 'La nostra flotta',
        sub: 'Biciclette selezionate per le strade di Firenze, sempre revisionate e pronte alla partenza.',
        perHour: "all'ora",
        perDay: 'al giorno',
        soldOut: 'Non disponibile',
        available: 'Disponibile',
        classic: 'Bicicletta Classica',
        ebike: 'E-Bike Elettrica',
        classicDesc: 'Elegante e comoda, ideale per il centro storico fiorentino. Cambio Shimano 7 velocità, cestino incluso.',
        ebikeDesc: 'Motore 250W per raggiungere Fiesole o Piazzale Michelangelo senza fatica. Autonomia 60km.',
      },
      booking: {
        title: 'Prenota, firma & parti',
        eyebrow: 'Prenotazione online',
        sub: 'Completa i 5 passi qui sotto. Riceverai email di conferma con contratto firmato in PDF.',
        step1: 'Date & Biciclette',
        step2: 'Optional',
        step3: 'Dati',
        step4: 'Contratto',
        step5: 'Pagamento',
        date: 'Data noleggio',
        startTime: 'Ora inizio',
        duration: 'Durata noleggio',
        dur1h: '1 ora',
        dur2h: '2 ore',
        dur4h: 'Mezza giornata',
        durDay: 'Giornata intera',
        howMany: 'Quante biciclette?',
        classic: 'Bicicletta Classica',
        ebike: 'E-Bike Elettrica',
        continue: 'Continua →',
        optionals: 'Optional & Accessori',
        optionalSub: 'Aggiunte per bicicletta (costo extra)',
        yourData: 'I tuoi dati',
        dataSub: 'Informazioni cliente e documento',
        firstName: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        phone: 'Telefono',
        docType: 'Tipo documento',
        docUpload: 'Carica documento d\'identità',
        docRequired: '(obbligatorio per legge)',
        docDrag: 'Clicca o trascina qui foto / scansione del documento',
        docHint: 'JPG, PNG, PDF · max 5MB · Fronte e retro',
        contract: 'Contratto & Firma digitale',
        contractSub: 'Leggi e firma il contratto di noleggio',
        signHere: 'Firma qui sotto',
        signClear: 'Cancella firma',
        signHint: 'Firma come sul tuo documento d\'identità',
        acceptContract: 'Ho letto e accetto il Contratto di noleggio e i Termini e Condizioni',
        acceptPrivacy: 'Accetto la Privacy Policy e il trattamento dei dati personali',
        acceptCaution: 'Autorizzo la pre-autorizzazione della cauzione sulla mia carta',
        acceptMarketing: 'Acconsento all\'invio di comunicazioni commerciali (facoltativo)',
        payment: 'Metodo di pagamento',
        paymentSub: 'Scegli come pagare in sicurezza',
        cautionInfo: 'Cauzione pre-autorizzata',
        cautionDesc: 'Verrà effettuata una pre-autorizzazione (blocco temporaneo) sulla tua carta. I fondi NON vengono addebitati e tornano disponibili entro 48h dalla restituzione.',
        cautionClassic: 'Cauzione bici classica',
        cautionEbike: 'Cauzione e-bike',
        confirmPay: 'Conferma & Paga',
        secure: 'Pagamento sicuro · SSL 256bit · Cancellazione gratuita 24h prima',
        summary: 'Riepilogo',
        total: 'Totale noleggio',
        caution: 'Cauzione (pre-auth)',
        notAvailable: 'Non disponibile in questo periodo',
        maxReached: 'Hai selezionato il massimo disponibile',
      },
      docs: {
        id: 'Carta d\'identità',
        passport: 'Passaporto',
        license: 'Patente di guida',
      },
      payment: {
        card: 'Carta',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        paypal: 'PayPal',
        transfer: 'Bonifico istantaneo',
      },
      features: {
        eyebrow: 'Perché sceglierci',
        title: 'Il noleggio più comodo di Firenze',
        location: 'Posizione unica',
        locationDesc: 'In Piazza Duomo, a 2 passi dal Battistero. Parti da zero km dal centro storico UNESCO.',
        ebike: 'E-Bike premium',
        ebikeDesc: 'Raggiungi Fiesole o Piazzale Michelangelo senza sforzo con le nostre e-bike 250W.',
        family: 'Family friendly',
        familyDesc: 'Seggiolini anteriori e posteriori, caschi di tutte le taglie, liberatoria inclusa.',
        contract: 'Contratto digitale',
        contractDesc: 'Firma online con firma grafometrica. Ricevi PDF via email. Tutto tracciato.',
        payments: '6 metodi di pagamento',
        paymentsDesc: 'Carta, PayPal, Apple Pay, Google Pay, Bonifico. Cauzione pre-autorizzata.',
        map: 'Itinerari esclusivi',
        mapDesc: 'Percorsi selezionati dal nostro staff per scoprire Firenze in modo autentico.',
      },
      where: {
        eyebrow: 'Dove siamo',
        title: 'Ci trovi in Piazza Duomo',
        address: 'Piazza del Duomo, Firenze',
        addressSub: 'Centro Storico · 50122 Firenze FI · Patrimonio UNESCO',
        open: 'Aperto 8:00 – 20:00',
        daily: 'Tutti i giorni',
        whatsapp: 'WhatsApp disponibile',
      },
      success: {
        title: 'Prenotazione confermata!',
        sub: 'Hai ricevuto una email con la conferma e il contratto firmato in PDF. Ti aspettiamo in Piazza Duomo!',
        close: 'Ottimo, a presto!',
      },
      footer: {
        tagline: 'Noleggio biciclette ed e-bike in Piazza Duomo. La tua avventura fiorentina inizia qui.',
        links: 'Link utili',
        legal: 'Legale',
        privacy: 'Privacy Policy',
        terms: 'Termini e Condizioni',
        cookie: 'Cookie Policy',
        withdrawal: 'Diritto di recesso',
        copyright: 'Tutti i diritti riservati',
      },
      cookie: {
        text: 'Utilizziamo cookie per migliorare la tua esperienza.',
        accept: 'Accetta',
        decline: 'Rifiuta',
      },
      lang: {
        it: 'Italiano',
        en: 'English',
        fr: 'Français',
        de: 'Deutsch',
        es: 'Español',
      },
    },
  },
  en: {
    translation: {
      nav: {
        bikes: 'Our Bikes',
        itineraries: 'Itineraries',
        booking: 'Book',
        where: 'Find us',
        bookNow: 'Book now',
      },
      hero: {
        tag: 'Piazza Duomo · Florence · Historic Centre',
        title: 'Discover Florence',
        subtitle: 'by bicycle',
        sub: 'Bike and e-bike rental in the heart of the city. Book online, sign digitally and ride away.',
        cta: 'Book now',
        discover: 'Explore bikes',
      },
      bikes: {
        title: 'Choose your bike',
        eyebrow: 'Our fleet',
        sub: 'Bikes selected for the streets of Florence, always serviced and ready to go.',
        perHour: 'per hour',
        perDay: 'per day',
        soldOut: 'Not available',
        available: 'Available',
        classic: 'Classic Bicycle',
        ebike: 'Electric E-Bike',
        classicDesc: 'Elegant and comfortable, ideal for the historic streets of Florence. Shimano 7-speed, basket included.',
        ebikeDesc: '250W motor to reach Fiesole or Piazzale Michelangelo effortlessly. 60km range.',
      },
      booking: {
        title: 'Book, sign & ride',
        eyebrow: 'Online booking',
        sub: 'Complete the 5 steps below. You will receive a confirmation email with your signed contract in PDF.',
        step1: 'Dates & Bikes',
        step2: 'Add-ons',
        step3: 'Your details',
        step4: 'Contract',
        step5: 'Payment',
        date: 'Rental date',
        startTime: 'Start time',
        duration: 'Duration',
        dur1h: '1 hour',
        dur2h: '2 hours',
        dur4h: 'Half day',
        durDay: 'Full day',
        howMany: 'How many bikes?',
        classic: 'Classic Bicycle',
        ebike: 'Electric E-Bike',
        continue: 'Continue →',
        optionals: 'Add-ons & Accessories',
        optionalSub: 'Per bike extras (additional cost)',
        yourData: 'Your details',
        dataSub: 'Customer info and ID document',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        docType: 'Document type',
        docUpload: 'Upload ID document',
        docRequired: '(required by law)',
        docDrag: 'Click or drag your document photo / scan here',
        docHint: 'JPG, PNG, PDF · max 5MB · Front and back',
        contract: 'Contract & Digital signature',
        contractSub: 'Read and sign the rental contract',
        signHere: 'Sign here',
        signClear: 'Clear signature',
        signHint: 'Sign as on your ID document',
        acceptContract: 'I have read and accept the Rental Contract and Terms & Conditions',
        acceptPrivacy: 'I accept the Privacy Policy and data processing',
        acceptCaution: 'I authorize the security deposit pre-authorization on my card',
        acceptMarketing: 'I consent to receive marketing communications (optional)',
        payment: 'Payment method',
        paymentSub: 'Choose how to pay securely',
        cautionInfo: 'Pre-authorized deposit',
        cautionDesc: 'A temporary hold will be placed on your card. Funds are NOT charged and released within 48h of return.',
        cautionClassic: 'Classic bike deposit',
        cautionEbike: 'E-bike deposit',
        confirmPay: 'Confirm & Pay',
        secure: 'Secure payment · SSL 256bit · Free cancellation 24h before',
        summary: 'Summary',
        total: 'Rental total',
        caution: 'Deposit (pre-auth)',
        notAvailable: 'Not available in this period',
        maxReached: 'Maximum available quantity reached',
      },
      docs: {
        id: 'Identity card',
        passport: 'Passport',
        license: 'Driving licence',
      },
      payment: {
        card: 'Card',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        paypal: 'PayPal',
        transfer: 'Instant transfer',
      },
      features: {
        eyebrow: 'Why choose us',
        title: 'Florence\'s most convenient rental',
        location: 'Unbeatable location',
        locationDesc: 'In Piazza Duomo, steps from the Baptistery. Start your ride from the UNESCO historic centre.',
        ebike: 'Premium e-bikes',
        ebikeDesc: 'Reach Fiesole or Piazzale Michelangelo effortlessly with our 250W e-bikes.',
        family: 'Family friendly',
        familyDesc: 'Front and rear child seats, helmets for all ages, waiver included.',
        contract: 'Digital contract',
        contractDesc: 'Sign online with graphometric signature. Receive PDF by email. Fully tracked.',
        payments: '6 payment methods',
        paymentsDesc: 'Card, PayPal, Apple Pay, Google Pay, Bank transfer. Deposit pre-authorized.',
        map: 'Exclusive itineraries',
        mapDesc: 'Routes handpicked by our team to discover Florence authentically.',
      },
      where: {
        eyebrow: 'Find us',
        title: 'We are in Piazza Duomo',
        address: 'Piazza del Duomo, Florence',
        addressSub: 'Historic Centre · 50122 Florence · UNESCO Heritage',
        open: 'Open 8:00 – 20:00',
        daily: 'Every day',
        whatsapp: 'WhatsApp available',
      },
      success: {
        title: 'Booking confirmed!',
        sub: 'You received an email with your confirmation and signed contract in PDF. See you in Piazza Duomo!',
        close: 'Great, see you soon!',
      },
      footer: {
        tagline: 'Bike and e-bike rental in Piazza Duomo. Your Florentine adventure starts here.',
        links: 'Useful links',
        legal: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms & Conditions',
        cookie: 'Cookie Policy',
        withdrawal: 'Right of withdrawal',
        copyright: 'All rights reserved',
      },
      cookie: {
        text: 'We use cookies to improve your experience.',
        accept: 'Accept',
        decline: 'Decline',
      },
      lang: { it: 'Italiano', en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español' },
    },
  },
  fr: {
    translation: {
      nav: { bikes: 'Nos vélos', itineraries: 'Itinéraires', booking: 'Réserver', where: 'Nous trouver', bookNow: 'Réserver' },
      hero: { tag: 'Piazza Duomo · Florence · Centre historique', title: 'Découvrez Florence', subtitle: 'à vélo', sub: 'Location de vélos et e-bikes au cœur de la ville. Réservez en ligne, signez numériquement et partez.', cta: 'Réserver', discover: 'Voir les vélos' },
      bikes: { title: 'Choisissez votre vélo', eyebrow: 'Notre flotte', sub: 'Vélos sélectionnés pour les rues de Florence, toujours révisés et prêts à partir.', perHour: 'par heure', perDay: 'par jour', soldOut: 'Indisponible', available: 'Disponible', classic: 'Vélo classique', ebike: 'E-Bike électrique', classicDesc: 'Élégant et confortable, idéal pour le centre historique. Shimano 7 vitesses, panier inclus.', ebikeDesc: 'Moteur 250W pour atteindre Fiesole sans effort. Autonomie 60km.' },
      booking: { title: 'Réservez, signez & partez', eyebrow: 'Réservation en ligne', sub: 'Complétez les 5 étapes. Vous recevrez un email de confirmation avec contrat signé en PDF.', step1: 'Dates & Vélos', step2: 'Options', step3: 'Vos données', step4: 'Contrat', step5: 'Paiement', date: 'Date de location', startTime: 'Heure de début', duration: 'Durée', dur1h: '1 heure', dur2h: '2 heures', dur4h: 'Demi-journée', durDay: 'Journée entière', howMany: 'Combien de vélos?', classic: 'Vélo classique', ebike: 'E-Bike électrique', continue: 'Continuer →', optionals: 'Options & Accessoires', optionalSub: 'Suppléments par vélo', yourData: 'Vos coordonnées', dataSub: 'Informations client et document', firstName: 'Prénom', lastName: 'Nom', email: 'Email', phone: 'Téléphone', docType: 'Type de document', docUpload: 'Télécharger pièce d\'identité', docRequired: '(obligatoire)', docDrag: 'Cliquez ou glissez votre document ici', docHint: 'JPG, PNG, PDF · max 5MB', contract: 'Contrat & Signature numérique', contractSub: 'Lisez et signez le contrat de location', signHere: 'Signez ici', signClear: 'Effacer', signHint: 'Signez comme sur votre pièce d\'identité', acceptContract: 'J\'ai lu et j\'accepte le Contrat et les CGV', acceptPrivacy: 'J\'accepte la Politique de confidentialité', acceptCaution: 'J\'autorise la pré-autorisation de la caution', acceptMarketing: 'J\'accepte les communications commerciales (optionnel)', payment: 'Mode de paiement', paymentSub: 'Choisissez comment payer', cautionInfo: 'Caution pré-autorisée', cautionDesc: 'Une retenue temporaire sera effectuée. Les fonds ne sont PAS débités et libérés sous 48h.', cautionClassic: 'Caution vélo classique', cautionEbike: 'Caution e-bike', confirmPay: 'Confirmer & Payer', secure: 'Paiement sécurisé · SSL · Annulation gratuite 24h avant', summary: 'Récapitulatif', total: 'Total location', caution: 'Caution (pré-auth)', notAvailable: 'Non disponible sur cette période', maxReached: 'Quantité maximale atteinte' },
      docs: { id: 'Carte d\'identité', passport: 'Passeport', license: 'Permis de conduire' },
      payment: { card: 'Carte', applePay: 'Apple Pay', googlePay: 'Google Pay', paypal: 'PayPal', transfer: 'Virement instantané' },
      features: { eyebrow: 'Pourquoi nous choisir', title: 'La location la plus pratique de Florence', location: 'Emplacement unique', locationDesc: 'En Piazza Duomo, à 2 pas du Baptistère.', ebike: 'E-Bikes premium', ebikeDesc: 'Atteignez Fiesole sans effort avec nos e-bikes 250W.', family: 'Famille bienvenue', familyDesc: 'Sièges enfant avant et arrière, casques pour tous.', contract: 'Contrat numérique', contractDesc: 'Signez en ligne. Recevez PDF par email.', payments: '6 modes de paiement', paymentsDesc: 'Carte, PayPal, Apple Pay, Google Pay, Virement.', map: 'Itinéraires exclusifs', mapDesc: 'Parcours sélectionnés par notre équipe.' },
      where: { eyebrow: 'Nous trouver', title: 'Nous sommes en Piazza Duomo', address: 'Piazza del Duomo, Florence', addressSub: 'Centre historique · 50122 Florence · Patrimoine UNESCO', open: 'Ouvert 8h – 20h', daily: 'Tous les jours', whatsapp: 'WhatsApp disponible' },
      success: { title: 'Réservation confirmée!', sub: 'Vous avez reçu un email avec votre confirmation et contrat signé. À bientôt en Piazza Duomo!', close: 'Parfait, à bientôt!' },
      footer: { tagline: 'Location de vélos en Piazza Duomo. Votre aventure florentine commence ici.', links: 'Liens utiles', legal: 'Légal', privacy: 'Politique de confidentialité', terms: 'CGV', cookie: 'Politique cookies', withdrawal: 'Droit de rétractation', copyright: 'Tous droits réservés' },
      cookie: { text: 'Nous utilisons des cookies pour améliorer votre expérience.', accept: 'Accepter', decline: 'Refuser' },
      lang: { it: 'Italiano', en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español' },
    },
  },
  de: {
    translation: {
      nav: { bikes: 'Fahrräder', itineraries: 'Routen', booking: 'Buchen', where: 'Standort', bookNow: 'Jetzt buchen' },
      hero: { tag: 'Piazza Duomo · Florenz · Historisches Zentrum', title: 'Entdecke Florenz', subtitle: 'mit dem Fahrrad', sub: 'Fahrrad- und E-Bike-Verleih im Herzen der Stadt. Online buchen, digital unterschreiben und losfahren.', cta: 'Jetzt buchen', discover: 'Fahrräder entdecken' },
      bikes: { title: 'Wähle dein Fahrrad', eyebrow: 'Unsere Flotte', sub: 'Fahrräder für die Straßen von Florenz ausgewählt, immer gewartet und startklar.', perHour: 'pro Stunde', perDay: 'pro Tag', soldOut: 'Nicht verfügbar', available: 'Verfügbar', classic: 'Klassisches Fahrrad', ebike: 'Elektrisches E-Bike', classicDesc: 'Elegant und komfortabel für die Altstadt. Shimano 7-Gang, Korb inklusive.', ebikeDesc: '250W Motor für Fiesole oder Piazzale Michelangelo mühelos. 60km Reichweite.' },
      booking: { title: 'Buchen, unterschreiben & losfahren', eyebrow: 'Online-Buchung', sub: 'Schließe die 5 Schritte ab. Du erhältst eine Bestätigungs-E-Mail mit dem signierten Vertrag als PDF.', step1: 'Datum & Fahrräder', step2: 'Extras', step3: 'Deine Daten', step4: 'Vertrag', step5: 'Zahlung', date: 'Mietdatum', startTime: 'Startzeit', duration: 'Dauer', dur1h: '1 Stunde', dur2h: '2 Stunden', dur4h: 'Halber Tag', durDay: 'Ganzer Tag', howMany: 'Wie viele Fahrräder?', classic: 'Klassisches Fahrrad', ebike: 'E-Bike', continue: 'Weiter →', optionals: 'Extras & Zubehör', optionalSub: 'Zusätze pro Fahrrad', yourData: 'Deine Daten', dataSub: 'Kundeninformationen und Ausweis', firstName: 'Vorname', lastName: 'Nachname', email: 'E-Mail', phone: 'Telefon', docType: 'Dokumententyp', docUpload: 'Ausweis hochladen', docRequired: '(gesetzlich erforderlich)', docDrag: 'Klicken oder Dokument hierher ziehen', docHint: 'JPG, PNG, PDF · max 5MB', contract: 'Vertrag & Digitale Unterschrift', contractSub: 'Lesen und unterschreiben Sie den Mietvertrag', signHere: 'Hier unterschreiben', signClear: 'Löschen', signHint: 'Unterschreiben wie auf Ihrem Ausweis', acceptContract: 'Ich habe den Mietvertrag und die AGB gelesen und akzeptiere sie', acceptPrivacy: 'Ich akzeptiere die Datenschutzrichtlinie', acceptCaution: 'Ich autorisiere die Kaution-Vorautorisierung', acceptMarketing: 'Ich stimme Marketingmitteilungen zu (optional)', payment: 'Zahlungsmethode', paymentSub: 'Wähle deine sichere Zahlungsmethode', cautionInfo: 'Vorgenehmigte Kaution', cautionDesc: 'Es wird eine vorübergehende Sperre auf Ihrer Karte vorgenommen. Gelder werden NICHT belastet und innerhalb von 48h freigegeben.', cautionClassic: 'Kaution klassisches Fahrrad', cautionEbike: 'Kaution E-Bike', confirmPay: 'Bestätigen & Bezahlen', secure: 'Sichere Zahlung · SSL · Kostenlose Stornierung 24h vorher', summary: 'Zusammenfassung', total: 'Mietbetrag', caution: 'Kaution (Vorautorisierung)', notAvailable: 'In diesem Zeitraum nicht verfügbar', maxReached: 'Maximale Anzahl erreicht' },
      docs: { id: 'Personalausweis', passport: 'Reisepass', license: 'Führerschein' },
      payment: { card: 'Karte', applePay: 'Apple Pay', googlePay: 'Google Pay', paypal: 'PayPal', transfer: 'Sofortüberweisung' },
      features: { eyebrow: 'Warum wir', title: 'Florenz\' bequemster Fahrradverleih', location: 'Einzigartige Lage', locationDesc: 'Am Piazza Duomo, 2 Schritte vom Baptisterium.', ebike: 'Premium E-Bikes', ebikeDesc: 'Erreiche Fiesole mühelos mit unseren 250W E-Bikes.', family: 'Familienfreundlich', familyDesc: 'Kindersitze vorne und hinten, Helme in allen Größen.', contract: 'Digitaler Vertrag', contractDesc: 'Online unterschreiben. PDF per E-Mail erhalten.', payments: '6 Zahlungsmethoden', paymentsDesc: 'Karte, PayPal, Apple Pay, Google Pay, Überweisung.', map: 'Exklusive Routen', mapDesc: 'Von unserem Team ausgewählte Routen.' },
      where: { eyebrow: 'Standort', title: 'Wir sind am Piazza Duomo', address: 'Piazza del Duomo, Florenz', addressSub: 'Historisches Zentrum · 50122 Florenz · UNESCO-Erbe', open: 'Geöffnet 8:00 – 20:00', daily: 'Täglich', whatsapp: 'WhatsApp verfügbar' },
      success: { title: 'Buchung bestätigt!', sub: 'Du erhältst eine E-Mail mit Bestätigung und signiertem Vertrag als PDF. Bis bald am Piazza Duomo!', close: 'Super, bis bald!' },
      footer: { tagline: 'Fahrradverleih am Piazza Duomo. Dein Florentiner Abenteuer beginnt hier.', links: 'Nützliche Links', legal: 'Rechtliches', privacy: 'Datenschutz', terms: 'AGB', cookie: 'Cookie-Richtlinie', withdrawal: 'Widerrufsrecht', copyright: 'Alle Rechte vorbehalten' },
      cookie: { text: 'Wir verwenden Cookies, um deine Erfahrung zu verbessern.', accept: 'Akzeptieren', decline: 'Ablehnen' },
      lang: { it: 'Italiano', en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español' },
    },
  },
  es: {
    translation: {
      nav: { bikes: 'Las bicicletas', itineraries: 'Itinerarios', booking: 'Reservar', where: 'Ubicación', bookNow: 'Reservar ahora' },
      hero: { tag: 'Piazza Duomo · Florencia · Centro Histórico', title: 'Descubre Florencia', subtitle: 'en bicicleta', sub: 'Alquiler de bicicletas y e-bikes en el corazón de la ciudad. Reserva online, firma digitalmente y sal a pedalear.', cta: 'Reservar ahora', discover: 'Ver bicicletas' },
      bikes: { title: 'Elige tu bicicleta', eyebrow: 'Nuestra flota', sub: 'Bicicletas seleccionadas para las calles de Florencia, siempre revisadas y listas para salir.', perHour: 'por hora', perDay: 'por día', soldOut: 'No disponible', available: 'Disponible', classic: 'Bicicleta clásica', ebike: 'E-Bike eléctrica', classicDesc: 'Elegante y cómoda para el centro histórico. Shimano 7 velocidades, cesta incluida.', ebikeDesc: 'Motor 250W para llegar a Fiesole sin esfuerzo. Autonomía 60km.' },
      booking: { title: 'Reserva, firma y pedalea', eyebrow: 'Reserva online', sub: 'Completa los 5 pasos. Recibirás un email de confirmación con el contrato firmado en PDF.', step1: 'Fechas & Bicicletas', step2: 'Extras', step3: 'Tus datos', step4: 'Contrato', step5: 'Pago', date: 'Fecha de alquiler', startTime: 'Hora de inicio', duration: 'Duración', dur1h: '1 hora', dur2h: '2 horas', dur4h: 'Medio día', durDay: 'Día completo', howMany: '¿Cuántas bicicletas?', classic: 'Bicicleta clásica', ebike: 'E-Bike eléctrica', continue: 'Continuar →', optionals: 'Extras y accesorios', optionalSub: 'Complementos por bicicleta', yourData: 'Tus datos', dataSub: 'Información del cliente y documento', firstName: 'Nombre', lastName: 'Apellido', email: 'Email', phone: 'Teléfono', docType: 'Tipo de documento', docUpload: 'Subir documento de identidad', docRequired: '(obligatorio por ley)', docDrag: 'Haz clic o arrastra tu documento aquí', docHint: 'JPG, PNG, PDF · máx 5MB', contract: 'Contrato & Firma digital', contractSub: 'Lee y firma el contrato de alquiler', signHere: 'Firma aquí', signClear: 'Borrar firma', signHint: 'Firma como en tu documento de identidad', acceptContract: 'He leído y acepto el Contrato y los Términos y Condiciones', acceptPrivacy: 'Acepto la Política de privacidad', acceptCaution: 'Autorizo la pre-autorización de la fianza', acceptMarketing: 'Acepto comunicaciones comerciales (opcional)', payment: 'Método de pago', paymentSub: 'Elige cómo pagar de forma segura', cautionInfo: 'Fianza pre-autorizada', cautionDesc: 'Se realizará un bloqueo temporal en tu tarjeta. Los fondos NO se cobran y se liberan en 48h.', cautionClassic: 'Fianza bicicleta clásica', cautionEbike: 'Fianza e-bike', confirmPay: 'Confirmar & Pagar', secure: 'Pago seguro · SSL · Cancelación gratuita 24h antes', summary: 'Resumen', total: 'Total alquiler', caution: 'Fianza (pre-auth)', notAvailable: 'No disponible en este período', maxReached: 'Cantidad máxima alcanzada' },
      docs: { id: 'DNI / Carné de identidad', passport: 'Pasaporte', license: 'Carné de conducir' },
      payment: { card: 'Tarjeta', applePay: 'Apple Pay', googlePay: 'Google Pay', paypal: 'PayPal', transfer: 'Transferencia instantánea' },
      features: { eyebrow: 'Por qué elegirnos', title: 'El alquiler más cómodo de Florencia', location: 'Ubicación única', locationDesc: 'En Piazza Duomo, a 2 pasos del Baptisterio.', ebike: 'E-Bikes premium', ebikeDesc: 'Llega a Fiesole sin esfuerzo con nuestras e-bikes de 250W.', family: 'Apto para familias', familyDesc: 'Sillas infantiles delanteras y traseras, cascos para todas las tallas.', contract: 'Contrato digital', contractDesc: 'Firma online. Recibe PDF por email.', payments: '6 métodos de pago', paymentsDesc: 'Tarjeta, PayPal, Apple Pay, Google Pay, Transferencia.', map: 'Itinerarios exclusivos', mapDesc: 'Rutas seleccionadas por nuestro equipo.' },
      where: { eyebrow: 'Ubicación', title: 'Estamos en Piazza Duomo', address: 'Piazza del Duomo, Florencia', addressSub: 'Centro Histórico · 50122 Florencia · Patrimonio UNESCO', open: 'Abierto 8:00 – 20:00', daily: 'Todos los días', whatsapp: 'WhatsApp disponible' },
      success: { title: '¡Reserva confirmada!', sub: 'Has recibido un email con la confirmación y el contrato firmado en PDF. ¡Te esperamos en Piazza Duomo!', close: '¡Perfecto, hasta pronto!' },
      footer: { tagline: 'Alquiler de bicicletas en Piazza Duomo. Tu aventura florentina empieza aquí.', links: 'Enlaces útiles', legal: 'Legal', privacy: 'Política de privacidad', terms: 'Términos y condiciones', cookie: 'Política de cookies', withdrawal: 'Derecho de desistimiento', copyright: 'Todos los derechos reservados' },
      cookie: { text: 'Usamos cookies para mejorar tu experiencia.', accept: 'Aceptar', decline: 'Rechazar' },
      lang: { it: 'Italiano', en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español' },
    },
  },
};

// Rileva lingua del browser
const browserLang = navigator.language.split('-')[0];
const supportedLangs = ['it', 'en', 'fr', 'de', 'es'];
const defaultLang = supportedLangs.includes(browserLang) ? browserLang : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('brf_lang') || defaultLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
